import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import EmailSubscribe from '../components/signin/EmailSubscribe.jsx';
import FlatButton from 'material-ui/FlatButton';
import Image from '../components/helpers/Image.jsx';
import preview from '../images/splash/preview-min.png';
import twitterImg from '../images/twitter.png';
import logo from '../images/logo.png';
import TweetEmbed from 'react-tweet-embed'
import './Splash.css';

export default class Splash extends Component {
  startGenerator() {
    browserHistory.push('/generate');
  }

  goToTwitter() {
    window.open('https://www.twitter.com/mixfont', '_blank');
  }

  render () {
    return (
      <div className="splash-background">
        <div className="splash-header">
          <div className="splash-header-logo">
            <Image src={logo} className="splash-header-logo-image" />
            MIXFONT
          </div>
          <div className="splash-header-links">
            <Link className="splash-header-link-text"
              to="/screensaver">
              Screensaver
            </Link>
            <Link className="splash-header-link-text"
              to="/shadows">
              Text shadows
            </Link>
          </div>
        </div>
        <div className="splash-main-text">
          <div className="splash-tagline">
            A modern font generator
          </div>
          <div className="splash-subtagline">
            Mixfont is a fun and simple way to discover and visualize new fonts.
          </div>
          <div className="splash-get-started">
            <FlatButton
              label="Start the Generator!"
              className="start-generator-button"
              backgroundColor="#30353a"
              hoverColor="#686C6F"
              onClick={this.startGenerator}
            />
          </div>
        </div>
        <div className="splash-numbers-container">
          <div className="splash-numbers-unit">
            1k+
            <div className="splash-numbers-text">
              unique fonts
            </div>
          </div>
          <div className="splash-numbers-unit">
            600k+
            <div className="splash-numbers-text">
              pairings
            </div>
          </div>
          <div className="splash-numbers-unit">
            132
            <div className="splash-numbers-text">
              languages
            </div>
          </div>
        </div>
        <div className="splash-image">
          &nbsp;
        </div>
        <div className="splash-details">
          <div className="splash-details-header">
            Find the perfect font for your next project.
          </div>
          <div className="splash-details-subtext">
            Whether it's for your website, greeting card, or paper, Mixfont puts font inspiration at your fingertips.
          </div>
          <div className="splash-preview-image-container"
            onClick={this.startGenerator}>
            <Image className="splash-preview-image" src={preview} />
          </div>
        </div>
        <div className="splash-box-container">
          <div className="splash-box">
            <div className="splash-box-header">
              <p>
                We're a team of designers and developers who felt that discovering the right fonts for every project was too challenging.
              </p>
              <p>
                So, we set out to make a fun and easy way to generate fun font pairings.
              </p>
              <hr className="splash-box-hr" />
              <p>
                The result? <b>Mixfont</b>, a font generator you can use to discover and visualize pairings in seconds.
              </p>
            </div>
          </div>
        </div>
        <div className="splash-tweets">
          <TweetEmbed id="870540914200064000" />
          <TweetEmbed id="870059895504199682" />
          <TweetEmbed id="867366354390843393" />
          <TweetEmbed id="867380130833985537" />
        </div>
        <div className="splash-details">
          <div className="splash-details-header">
            Your favorite new font, at your fingertips
          </div>
          <div className="splash-get-started">
            <FlatButton
              label="Get started"
              className="start-generator-button"
              backgroundColor="#30353a"
              hoverColor="#686C6F"
              onClick={this.startGenerator}
            />
          </div>
        </div>
        <div className="splash-footer">
          <div className="splash-sign-in">
            <div className="splash-beta">
              Looking for more? Sign up for our mailing list to get the latest updates.
            </div>
            <EmailSubscribe />
          </div>
          <div className="social-media-bar">
            <div className="social-media-twitter" onClick={this.goToTwitter}>
              <img src={twitterImg} alt="Twitter link" className="twitter-image" />
            </div>
          </div>
          <div className="footer-bar">
            <div className="splash-header-logo">
              MIXFONT
            </div>
            <div className="footer-copyright">
              © 2017 Mixfont Inc.
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Splash.jsx